import React, { useEffect, useState } from "react";
import "./uploaded-file-banner.scss";
import { UploadedDocIcon } from "../../SVG/uploaded-doc";
import { RedBinIcon } from "../../SVG/red-bin";
import { CloseRedIcon } from "../../SVG/close-red";

interface UploadedFileBannerProps {
  fileName: string;
  deleteUploadedFile: () => void;
  currentProgress: number;
}

export function UploadedFileBanner(props: UploadedFileBannerProps) {
  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    props.currentProgress && setUploadProgress(props.currentProgress);
  }, [props.currentProgress]);
  return (
    <>
      {" "}
      <div className="uploaded-file-banner-container">
        <div className="uploaded-file-banner-container__details-container">
          <div className="image-container">
            <UploadedDocIcon />
          </div>
          <div className="file-name-container">
            <div className="file-name">{props.fileName}</div>
            <div className="uploading-state">
              {Math.round(uploadProgress) >= 100
                ? "Upload Completed"
                : "Uploading..."}
            </div>
          </div>
          <div className="action" onClick={props.deleteUploadedFile}>
            {Math.round(uploadProgress) >= 100 ? (
              <>
                <RedBinIcon />
                <div className="close-text">Delete</div>
              </>
            ) : (
              <>
                <CloseRedIcon />
                <div className="close-text">Cancel</div>
              </>
            )}
          </div>
        </div>
        <div className="uploaded-file-loader-container">
          <div
            className="inner-loader-container"
            style={{ width: `${uploadProgress}%` }}
          ></div>
        </div>
      </div>
    </>
  );
}
